import type { Unit } from './types';

export class SpatialGrid {
  private readonly cells = new Map<string, Unit[]>();

  constructor(private readonly cellSize: number) {}

  rebuild(units: readonly Unit[]): void {
    this.cells.clear();
    for (const unit of units) {
      const key = this.key(unit.x, unit.y);
      const cell = this.cells.get(key);
      if (cell) cell.push(unit);
      else this.cells.set(key, [unit]);
    }
  }

  nearby(x: number, y: number): Unit[] {
    const cx = Math.floor(x / this.cellSize);
    const cy = Math.floor(y / this.cellSize);
    const result: Unit[] = [];
    for (let ox = -1; ox <= 1; ox += 1) {
      for (let oy = -1; oy <= 1; oy += 1) {
        const cell = this.cells.get(`${cx + ox}:${cy + oy}`);
        if (cell) result.push(...cell);
      }
    }
    return result;
  }

  private key(x: number, y: number): string {
    return `${Math.floor(x / this.cellSize)}:${Math.floor(y / this.cellSize)}`;
  }
}
